<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br />
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-2">
            <label for="transactionDate">Date</label>
            <date-picker ref="tran" v-model="transactionDate" valueType="format" v-if="!englishDateEnabled" />
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="transactionDate"
              v-model="transactionDate" />
          </div>

          <div class="p-field p-col-12 p-md-3">
            <label for="voucher">Voucher</label>
            <InputText v-model="voucherNo" id="voucher" disabled />
          </div>
          <div class="p-field p-col-12 p-md-2 radiobox">
            <div class="radiobox-itm">
              <Checkbox id="city1" class="" name="city" v-model="isPdcTransaction" :binary="true" />
              <label for="city1">Pdc</label>
            </div>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label>Account</label>
            <AutoComplete v-model="account" filterMatchMode='contains' :suggestions="filteredAccounts"
              @complete="searchItem($event)" field="name" ref="itm" @input="nepaliDate">
            </AutoComplete>
          </div>

          <div class="p-field p-col-12 p-md-1 align-self-end">
            <accountMasterDialog class="btn-btm-0" v-tooltip.top="'Add Account'"
              @set_account_master="set_account_master" />
          </div>
          <div v-if="!this.account.enableCostCenter" class="p-field p-col-12 p-md-2">
            <label for="drAmount">Debit Amount</label>
            <InputNumber id="drAmount" bodyStyle="text-align: right" v-model="txnAmountDr" :minFractionDigits="2"
              :maxFracionDigits="4" v-if="txnAmountCr > 0" disabled />
            <InputNumber onfocus="if (this.value === '0.00'){this.value = ''
}" id="drAmount" bodyStyle="text-align: right" v-model="txnAmountDr" :minFractionDigits="2" :maxFracionDigits="4"
              v-else />
          </div>

          <div v-if="this.account.enableCostCenter" class="p-field p-col-12 p-md-1">
            <label for="drAmount">Debit Amount</label>
            <InputNumber id="drAmount" bodyStyle="text-align: right" v-model="txnAmountDr" :minFractionDigits="2"
              :maxFracionDigits="4" v-if="txnAmountCr > 0" disabled />
            <InputNumber onfocus="if (this.value === '0.00'){this.value = ''
}" id="drAmount" bodyStyle="text-align: right" v-model="txnAmountDr" :minFractionDigits="2" :maxFracionDigits="4"
              v-else />
          </div>

          <div v-if="!this.account.enableCostCenter" class="p-field p-col-12 p-md-2">

            <label for="crAmount">Credit Amount</label>
            <InputNumber id="crAmount" bodyStyle="text-align: right" v-model="txnAmountCr" :minFractionDigits="2"
              :maxFracionDigits="4" v-if="txnAmountDr > 0" disabled />
            <InputNumber onfocus="if (this.value === '0.00'){this.value = ''
                }" id="crAmount" bodyStyle="text-align: right" v-model="txnAmountCr" :minFractionDigits="2"
              :maxFracionDigits="4" v-else />

          </div>
          <div v-if="this.account.enableCostCenter" class="p-field p-col-12 p-md-1">

            <label for="crAmount">Credit Amount</label>
            <InputNumber id="crAmount" bodyStyle="text-align: right" v-model="txnAmountCr" :minFractionDigits="2"
              :maxFracionDigits="4" v-if="txnAmountDr > 0" disabled />
            <InputNumber onfocus="if (this.value === '0.00'){this.value = ''
                }" id="crAmount" bodyStyle="text-align: right" v-model="txnAmountCr" :minFractionDigits="2"
              :maxFracionDigits="4" v-else />

          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="shortNarr">Short Narration</label>
            <InputText id="shortNarr" v-model="narration3" />
          </div>
          <div class="p-field p-mt-5 p-col-12 p-md-2" v-if="account.enableCostCenter">
            <Button class="p-button-raised " @click.prevent="openCostCenter" label="Cost Center" />

          </div>

          <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="!account.bankAccount">
            <!-- <Button class="p-button-raised p-button-rounded"
                    @click.prevent=""/> -->
            <Button class="p-button p-component addNewBtn btn-btm-0" @click.prevent="addTransactionToDTO"
              :label="!editDTO ? 'Add' : 'Update'" />
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="!account.nankAccount">
            <Button v-show="editDTO" class="p-button-raised p-button-danger" @click.prevent="resetAccountDto"
              label="Cancel" />
          </div>
        </div>
        <!-- </div> -->
        <!-- <div class="form-group container" > -->
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="closingBalance" v-if="account.closingBalance >= 0 || account.closingBalance < 0">Cur.
              Bal:</label>
            <b style="color:red;" v-if="account.closingBalance > 0">{{ (account.closingBalance).toFixed(2) + ' ' + 'Cr'
            }}</b>

            <b v-else-if="account.closingBalance === 0">
              {{ (account.closingBalance).toFixed(2) }}
            </b>
            <b style="color:green;" v-else-if="account.closingBalance < 0">
              {{ (account.closingBalance).toFixed(2) * (-1) + ' ' + 'Dr' }}
            </b>
          </div>
          <div class="p-field p-col-12 p-md-2"></div>
          <div class="p-field p-col-12 p-md-2" v-show="account.bankAccount">
            <label for="">Cheque Date</label>
            <date-picker v-model="chequeDate" valueType="format" v-if="!englishDateEnabled" />
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="chequeDate"
              v-model="chequeDate" />
          </div>
          <!-- {{chequeDate}} -->
          <div class="p-field p-col-12 p-md-2" v-show="account.bankAccount">
            <label for="Pdc">Cheque No</label>
            <input type="text" class="form-control" v-model="chequeNumber" />
          </div>

          <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="account.bankAccount">
            <Button class="p-button-raised" @click.prevent="addTransactionToDTO" :label="!editDTO ? 'Add' : 'Update'" />
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5" v-if="account.bankAccount">
            <Button v-show="editDTO" class="p-button-raised p-button-danger" @click.prevent="resetAccountDto"
              label="Cancel" />
          </div>
        </div>
      </form>
      <div class="p-field p-col-12 p-md-12">
        <div>
          <div class="jouscroll">
            <table class="table table-bordered ">
              <thead>
                <tr>
                  <th scope="col">SN</th>
                  <th scope="col">Account Name</th>
                  <th scope="col">Debit Amount</th>
                  <th scope="col">Credit Amount</th>
                  <th scope="col">Cheque Date</th>
                  <th scope="col">Cheque Number</th>
                  <th scope="col" v-if="!account.enableCostCenter">Cost Center</th>
                  <th scope="col">Short Narration</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody v-for="(account, index) in transactionDetailDTOList " :key="index">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ account.accountMaster.name }}</td>
                  <td style="text-align:right">{{ account.drCr == 'D' ? account.txnAmount : '' }}</td>
                  <td style="text-align:right">{{ account.drCr == 'C' ? account.txnAmount : '' }}</td>
                  <td>{{ account.chequeDate }}</td>
                  <td>{{ account.chequeNumber }}</td>
                  <td v-if="!account.enableCostCenter">
                    <a href="" @click.prevent="viewCostCenterDialog(account)">Cost Center</a>
                    <!-- <Button label="Cost Center" class="p-button-raised p-button-info"
                          @click="viewCostCenterDialog(account)"
                  /> -->
                  </td>
                  <td>{{ account.narration3 }}</td>
                  <td>
                    <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                      @click="editAccountFromDTO(account, index)" />
                    <Button icon="pi pi-trash" v-if="!editDTO" class="p-button-raised p-button-danger"
                      @click="deleteAccountFromDTO(account, index)" />
                    <Button icon="pi pi-trash" v-else class="p-button-raised p-button-danger"
                      @click="deleteAccountFromDTO(account, index)" disabled />
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2">Total:</td>
                  <td>{{ drtotal.toFixed(4) }}</td>
                  <td>{{ crTotal.toFixed(4) }}</td>
                  <td>&nbsp;</td>
                  <td colspan="1">Diff Amt:</td>
                  <td colspan="1">
                    <span style="margin-left:2em;color:green;font-size: 12px;" v-if="calculation === 0">{{
                      calculation.toFixed(4) }}</span>
                    <span v-else style="margin-left:2em;color:red;font-size: 12px;">{{ calculation.toFixed(4) }}</span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <!-- <hr> -->

      <!-- <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-3">
          <label class="_drcr" style="margin-left:14em;">Total</label>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <span style="margin-left:12em;color:#3c8dbc;font-size: 12px;">{{ drtotal.toFixed(4) }}</span>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <span style="margin-left:5em;color:#3c8dbc;font-size: 12px;">{{ crTotal.toFixed(4) }}</span>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label class="_drcr">Diff Amt</label>
          <span style="margin-left:2em;color:green;font-size: 12px;"
                v-if="calculation===0">{{ calculation.toFixed(4) }}</span>
          <span v-else style="margin-left:2em;color:red;font-size: 12px;">{{ calculation.toFixed(4) }}</span>
        </div>
         <div class="p-field p-col-12 p-md-2" v-if="this.$store.getters.modules.includes('5.31')">
            <Button id="imageUpload" @click.prevent="showItemUpload" class="p-button-raised"
                    label="Upload Image"/>
          </div>
      </div> -->

      <!-- <hr> -->
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-3">
          <label for="narration1">Narration</label>
          <TextArea id="narration1" cols="15" rows="6" v-model="narration" />
        </div>
        <div class="p-field p-col-12 p-md-3"></div>
        <div class="p-field p-col-12 p-md-1 p-pt-6" v-if="journal !== undefined">
          <Button class="p-button-raised p-button-danger" @click="goBack()" label="Cancel" />
        </div>
        <div class="p-field p-col-12 p-md-1 p-pt-6" v-if="journal == undefined">
          <Button class="p-button-raised p-button-warning" icon="pi pi-refresh" @click.prevent="reset" label="Reset" />
        </div>
        <div class="p-field p-col-12 p-md-1 p-pt-6">
          <Button class="p-button-raised" icon="pi pi-save" @click.prevent="saveJournalEntry"
            :label="!editing ? 'Save' : 'Update'" />
        </div>
        <div class="p-field p-col-12 p-md-1 p-pt-6">
          <Button class="p-button-raised p-button-info" @click="openVoucher()" icon="pi pi-print" label="Print" />
        </div>
        <div class="p-field p-col-12 p-md-2 p-pt-6">
          <Button class="p-button-raised p-button-secondary" icon="pi pi-download" label="Generate PDF" />
        </div>
      </div>
    </div>
    <Dialog header="Cost Center" :visible.sync="costCenterDialog" :style="{ width: '60vw' }" :modal="true" :closable=false
      :contentStyle="{ 'overflow': 'visible' }">
      <DataTable :value="costCenterList" :paginator="true" :rows="5" class="p-datatable-responsive p-datatable-gridlines">
        <Column header="Name" field="costCenter">
          <template #body="slotProps">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="costCenterForTransactionLists"
                  optionLabel="name" v-if="viewCostCenter" disabled placeholder="Select One" :filter="true" />
                <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="costCenterForTransactionLists"
                  optionLabel="name" placeholder="Select One" v-else :filter="true" />
              </div>
            </div>
          </template>
        </Column>
        <Column header="Amount" field="costCenterAmt">
          <template #body="slotProps">
            <InputNumber v-if="viewCostCenter" disabled v-model="slotProps.data[slotProps.column.field]" mode="decimal"
              locale="en-IN" :minFractionDigits="2" />
            <InputNumber v-else v-model="slotProps.data[slotProps.column.field]" mode="decimal" locale="en-IN"
              :minFractionDigits="2" />
          </template>
        </Column>
        <Column v-if="!viewCostCenter" header="Action">
          <template #body="slotProps">
            <Button class="p-button-raised p-button-rounded" icon="pi pi-plus" @click.prevent="addToCostCenterList()" />
            <Button class="p-button-raised p-button-danger" icon="pi pi-minus"
              @click.prevent="subCostCenterList(slotProps.index)" />
          </template>
        </Column>
      </DataTable>
      <template #footer>
        <Button class="p-button-raised p-button-rounded" label="Save" @click.prevent="addCostCenter" />
        <Button class="p-button-raised p-button-danger" label="Cancel" @click.prevent="cancelCostCenter" />
      </template>
    </Dialog>
    <Dialog header="Item Image Upload" :modal="true" :visible.sync="showItemUploadDialog" :style="{ width: '50vw' }">
      <input id="imageUpload" type="file" style="margin-bottom: 2em;" @change="onFileSelect" multiple />
      <Carousel :value="url" :numVisible="2" :numScroll="2">
        <template #item="slotProps">
          <div class="product-item">
            <div class="product-item-content">
              <div class="p-mb-3">
                <img :src="slotProps.data" style="height:250px;width:250px" class="product-image" />
              </div>
              <div>
                <div class="car-buttons p-mt-5">
                  <Button class="p-button-raised p-button-danger p-mr-2"
                    @click.prevent="removeImage(slotProps.data, slotProps)" label="Remove" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </Carousel>
    </Dialog>
  </section>
</template>
<script>
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import accountMasterDialog from '../accountDialog/AccountMasterDialog'
import InputText from 'primevue/inputtext'
import TextArea from 'primevue/textarea'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Carousel from 'primevue/carousel'

export default {
  name: 'journalEntry',
  props: ['journal'],
  data() {
    return {
      name: '',
      englishDateEnabled: true,
      transactionDate: null,
      account: '',
      txnAmountDr: 0,
      txnAmountCr: 0,
      narration3: '',
      narration: '',
      drCr: '',
      drtotal: 0,
      crTotal: 0,
      difference: 0,
      chequeDate: null,
      chequeDateNp: null,
      chequeNumber: '',
      transactionDetailDTOList: [],
      transactionDeleteList: [],
      bank: false,
      editing: false,
      voucherNo: null,
      editDTO: false,
      index: null,
      tranId: null,
      tranModuleType: null,
      loading: true,
      cheque: false,
      filteredAccounts: null,
      isPdcTransaction: false,
      data: '',
      costCenterDialog: false,
      viewCostCenter: false,
      costCenterList: [{
        costCenter: '',
        costCenterAmt: 0
      }],
      costCenterDropDown: [],
      showItemUploadDialog: false,
      url: [],
      deletedImage: [],
      imageList: [],
      images: []
    }
  },
  computed: {
    accountMasterList() {
      return this.$store.state.accounting.accountList
    },
    costCenterForTransactionLists() {
      return this.$store.state.costCenter.costCenterForTransactionLists
    },
    calculation() {
      let difference = 0
      this.drtotal = 0
      this.crTotal = 0
      for (let i = 0; i < this.transactionDetailDTOList.length; i++) {
        if (this.transactionDetailDTOList[i].drCr === 'D') {
          this.drtotal += parseFloat(this.transactionDetailDTOList[i].txnAmount)
        } else {
          this.crTotal += parseFloat(this.transactionDetailDTOList[i].txnAmount)
        }
        difference = parseFloat(this.drtotal) - parseFloat(this.crTotal)
      }
      return difference
    }
  },
  mounted() {
    const promises = []
    if (this.journal === undefined) {
      promises.push(this.maxVoucherNo())
    }
    promises.push(this.accountList())
    if (this.journal !== undefined) {
      promises.push(this.editjournal())
    }
    promises.push(this.findCostCenterGroup())
    Promise.all(promises)
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Failed to load data',
          life: 10000
        })
      })
    this.checkEnglish()
    if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.state.isEnglishDateEnabled && this.journal === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async maxVoucherNo() {
      let response = await this.$store.dispatch('maxVoucherNo')
      if (this.journal === undefined) {
        this.voucherNo = response.data.data
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.voucherNo
        this.narration
      }
    },
    async accountList() {
      await this.$store.dispatch('accountMasterList')
    },
    addTransactionToDTO() {
      if (this.account === '') {
        this.$toast.add({ severity: 'error', summary: '', detail: 'Please select account!', life: 10000 })
        return
      } else if (this.txnAmountDr <= 0 && this.txnAmountCr <= 0) {
        this.$toast.add({ severity: 'error', summary: '', detail: 'Please enter amount!', life: 10000 })
        return
      }
      if (this.account.id === undefined) {
        this.$toast.add({ severity: 'error', summary: '', detail: 'Please Select valid account!', life: 10000 })
        return
      }
      if (this.txnAmountDr > 0) {
        this.drCr = 'D'
        this.txnAmount = this.txnAmountDr
      } else {
        this.txnAmount = this.txnAmountCr
        this.drCr = 'C'
      }
      if (!this.account.enableCostCenter) {
        this.costCenterList = null
      }
      let transaction = {
        accountMaster: this.account,
        narration3: this.narration3,
        txnAmount: this.txnAmount,
        chequeDate: this.chequeDate,
        chequeDateNp: this.chequeDate,
        chequeNumber: this.chequeNumber,
        drCr: this.drCr,
        costCenterTransactionDTOList: this.costCenterList
      }
      if (!this.editDTO) {
        this.transactionDetailDTOList.push({ ...transaction })
      } else {
        this.transactionDetailDTOList.splice(this.index, 1, { ...transaction })
      }
      this.resetAccountDto()
      this.focusInput()
    },
    editAccountFromDTO(data, index) {
      this.resetAccountDto()
      // this.checkForChequeDate()
      this.editDTO = true
      this.account = data.accountMaster
      this.drCr = data.drCr
      if (this.drCr === 'D') {
        this.txnAmountDr = data.txnAmount
      } else {
        this.txnAmountCr = data.txnAmount
      }
      this.chequeNumber = data.chequeNumber
      this.chequeDateNp = data.chequeDate
      this.chequeDate = data.chequeDate
      // this.accountMasterId = data.accountMaster.id
      this.narration3 = data.narration3
      this.index = index
      this.costCenterList = data.costCenterTransactionDTOList
    },
    async saveJournalEntry() {
      let response = ''
      let journalObject = {
        transactionDate: this.transactionDate,
        transactionNepaliDate: this.transactionDate,
        narration1: this.narration,
        // chequeNumber: this.chequeNumber,
        // chequeDate: this.chequeDate,
        // chequeDateNp: this.chequeDate,
        tranId: this.tranId,
        tranModuleType: this.tranModuleType,
        transactionDetailDTOList: this.transactionDetailDTOList,
        // transactionDeleteList: this.transactionDeleteList,
        pdcTransaction: this.isPdcTransaction
      }
      // const formData = new FormData()
      // formData.append('journalObject', JSON.stringify(formData))
      // for (let i = 0; i < this.images.length; i++) {
      //   formData.append('files', this.images[i])
      // }
      if (this.transactionDetailDTOList.length < 1) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'The transaction must have at least two transaction heads!',
          life: 10000
        })
        return
      }
      if (this.calculation !== 0) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Debit and credit amount should be equal!',
          life: 10000
        })
        return
      }
      const formData = new FormData()
      formData.append('journalObject', JSON.stringify(journalObject))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      if (!this.editing) {
        this.loading = true
        try {
          response = await this.$store.dispatch('saveJournalEntry', formData)
          this.data = response.data.data
          if (response.data.status === 'SUCCESS') {
            this.$toast.add({ severity: 'success', summary: '', detail: response.data.message, life: 10000 })
            await this.maxVoucherNo()
            this.reset()
          } else {
            this.$toast.add({ severity: 'error', summary: '', detail: response.data.message, life: 10000 })
          }
        } catch (e) {
          this.$toast.add({
            severity: 'error',
            summary: '',
            detail: 'Something wrong!',
            life: 3000
          })
          this.loading = false
        }
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateJournalEntry', formData)
        this.loading = false
        this.editing = false
        this.$router.back()
      }
    },
    async editjournal() {
      let response = await this.$store.dispatch('loadaccountLedger', this.journal)
      if (response.data.status === 'SUCCESS') {
        this.editing = !this.editing
        let resp = response.data.data
        this.voucherNo = resp.voucher
        if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
          this.transactionDate = resp.transactionNepaliDate
        } else {
          this.transactionDate = resp.transactionDate
        }
        this.transactionDetailDTOList = resp.transactionDetailDTOList
        this.narration = resp.narration1
        this.tranId = resp.tranId
        this.chequeDate = resp.chequeDate
        this.chequeDateNp = resp.chequeDateNp
        this.tranModuleType = this.journal.tranModuleType
        this.isPdcTransaction = resp.pdcTransaction
      }
    },
    set_account_master(data) {
      this.account = data
    },
    cancelCostCenter() {
      this.costCenterDialog = false
    },
    openVoucher() {
      let data = this.data
      this.$router.push({ name: 'voucher', params: { printData: data } })
    },
    resetAccountDto() {
      this.account = ''
      this.txnAmountDr = 0
      this.txnAmountCr = 0
      this.narration3 = ''
      this.editDTO = false
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        this.chequeDate = this.$store.state.nepaliNewDate
      } else {
        this.chequeDate = new Date().toISOString().slice(0, 10)
      }
      this.chequeNumber = ''
      this.costCenterDialog = false
      this.costCenterList = []
    },
    showItemUpload() {
      this.showItemUploadDialog = true
    },
    onFileSelect(event) {
      let selectedFile = Array.prototype.slice.call(event.target.files)
      selectedFile.forEach(f => {
        let fileExtension = f.name.split('.').pop()
        console.log(fileExtension)
        if (fileExtension !== 'jpg' && fileExtension !== 'jpeg' && fileExtension !== 'png' && fileExtension !== 'JPG') {
          this.$toast.add({ severity: 'error', summary: '', detail: 'Please select Valid Image!', life: 10000 })
          return
        }
        this.images.push(f)
        let reader = new FileReader()
        reader.onload = (e) => {
          this.url.push(e.target.result)
          // console.log(e.target.result)
        }
        reader.readAsDataURL(f)
      })
    },
    viewImage() {
      this.openImageViewer = true
    },
    back() {
      this.openImageViewer = false
    },
    removeImage(data, props) {
      if (data.id !== undefined && data !== null) {
        this.deletedImage.push(data.id)
      }
      this.url.splice(props.index, 1)
      this.imageList.splice(props.index, 1)
    },
    deleteAccountFromDTO(data, id) {
      // this.checkForChequeDate()
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        this.chequeDate = this.$store.getters.nepaliNewDate
      } else {
        this.chequeDate = new Date().toISOString().slice(0, 10)
      }
      if (this.editing && data.id !== null) {
        this.transactionDeleteList.push({ ...data })
      }
      this.transactionDetailDTOList.splice(id, 1)
    },
    reset() {
      this.resetAccountDto()
      this.transactionDetailDTOList = []
      this.editing = false
      this.isPdcTransaction = false
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.transactionDate = new Date().toISOString().slice(0, 10)
        this.chequeDate = this.$store.getters.nepaliNewDate
      }
      this.costCenterDialog = false
    },
    setNepaliDate() {
      if (this.journal === undefined) {
        this.transactionDate = this.$store.getters.nepaliNewDate
        this.chequeDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.transactionDate = new Date().toISOString().slice(0, 10)
      this.chequeDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        $('#transactionDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.transactionDate = $('#transactionDate').val()
          }
        })
        if (this.account.bankAccount === true) {
          this.setNepaliDate()
          $('#chequeDate').nepaliDatePicker({
            ndpYear: true,
            ndpMonth: true,
            ndpYearCount: 10,
            disableBefore: this.$store.state.startDate,
            disableAfter: this.$store.state.endDate,
            onChange: () => {
              this.chequeDate = $('#chequeDate').val()
            }
          })
        } else {
          this.chequeDate = ''
        }
      }
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredAccounts = [...this.accountMasterList]
        } else {
          this.filteredAccounts = this.accountMasterList.filter((account) => {
            return account.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    viewCostCenterDialog(data) {
      this.viewCostCenter = true
      this.costCenterList = data.costCenterTransactionDTOList
      this.costCenterDialog = true
    },
    openCostCenter() {
      let costCenter = {
        costCenter: this.costCenter,
        costCenterAmt: this.costCenterAmt
      }
      if (this.costCenterList.length === 0) {
        this.costCenterList.push(costCenter)
      }
      this.costCenterDialog = true
      this.viewCostCenter = false
    },
    async findCostCenterGroup() {
      await this.$store.dispatch('loadCostCenterForTransaction')
    },
    addToCostCenterList() {
      let costCenter = {
        costCenter: this.costCenter,
        costCenterAmt: this.costCenterAmt
      }
      this.costCenterList.push(costCenter)
    },
    subCostCenterList(index) {
      if (this.costCenterList.length !== 1) {
        this.costCenterList.splice(index, 1)
      }
    },
    addCostCenter() {
      this.costCenterDialog = false
      // this.costCenterList =
    },
    goBack() {
      if (this.transactionDeleteList.length > 0) {
        this.journal.transactionDetailDTOList = this.transactionDeleteList
      }
      this.$router.back()
    }
    // checkForChequeDate() {
    //   if (this.account.isBankAccount || this.account.isBankAccount === undefined) {
    //     if (this.account.isBankAccount) {
    //       this.bank = true
    //     } else if (this.account.isBankAccount === undefined) {
    //       this.bank = false
    //     } else if (!this.account.isBankAccount) {
    //       this.bank = false
    //     }
    //     if (this.chequeNumber !== '') {
    //       this.cheque = true
    //     } else if (this.chequeNumber === '') {
    //       this.cheque = false
    //     }
    //   }
    // }
  },
  components: {
    Dropdown,
    DatePicker,
    Checkbox,
    AutoComplete,
    InputNumber,
    InputMask,
    accountMasterDialog,
    Button,
    InputText,
    TextArea,
    DataTable,
    Column,
    Carousel,
    Dialog
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
._drcr {
  color: red;
}
</style>



// WEBPACK FOOTER //
// journal.vue?fe71b8fa